export default [
  {
    path: "/files",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "files_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Files", to: "files_list" }],
          permission: "file:view",
          title: "Files",
        },
      },
      {
        name: "files_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [{ label: "Files", to: "files_list" }],
          permission: "file:create",
          title: "Files - Cadastro",
        },
      },
      {
        name: "files_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "Files", to: "files_list" }],
          permission: "file:edit",
          title: "Files - Edição",
        },
      },
    ],
  },
];
